<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="end" spaced>
          <FormButtonMenu
            type="secundario"
            :options="operacoesOptions"
            @click="op => selectOperacao(op)"
            :loading="loadingAcao"
          >
            Operação em massa
          </FormButtonMenu>
          <FormButtonMenu
            type="secundario"
            :options="planilhaOptions"
            @click="op => selectOperacao(op)"
          >
            Operação em planilha
          </FormButtonMenu>
          <FormButton text="Novo conjunto" type="primario" @click="onNew" />
        </FormButtonGroup>
      </template>
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        :filters="filters"
        sortBy="nome"
        :sortDesc="false"
        @click="onClick"
        ref="datatable"
        showSelect
        search
        noHideFilters
        v-model="conjuntoSelecionados"
        :auto-search="false"
      >
        <template v-slot:disponivel="{ col }">
          <Chip v-if="col" color="green" text="Sim" :small="true" />
          <Chip v-else color="cyan" text="Não" :small="true" />
        </template>
        <template v-slot:inicio_vigencia="{ col }">
          {{ formatVigenciaForDisplay(col) }}
        </template>
        <template v-slot:fim_vigencia="{ col }">
          {{ formatVigenciaForDisplay(col) }}
        </template>
        <template v-slot:tem_imagem="{ col }">
          <Chip v-if="col" color="green" text="Sim" :small="true" />
          <Chip v-else color="cyan" text="Não" :small="true" />
        </template>
        <template v-slot:idproduto="{ row }">
          <FormButtonMenu
            icon
            :options="tableOptions"
            :loading="loadingRow[row.idcadastroextraproduto]"
            @click="op => selectOption(row, op)"
          >
            <v-icon size="15">fas fa-ellipsis-v</v-icon>
          </FormButtonMenu>
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <EdicaoEmPlanilha
        v-if="modalEdicaoEmPlanilha.open"
        :modelo="modalEdicaoEmPlanilha.modelo"
        @close="modalEdicaoEmPlanilha.open = false"
      />
    </transition>
    <transition name="slide-popup" mode="out-in">
      <ProdutoAssociarModal
        v-if="modalAssociar"
        @close="modalAssociar = false"
        @submit="aplicaCategorias"
      />
    </transition>
    <transition name="slide-popup" mode="out-in">
      <ProdutoAssociarTags
        v-if="modalAssociarTags"
        @close="modalAssociarTags = false"
        @submit="aplicarTags"
      />
    </transition>
    <transition name="slide-popup" mode="out-in">
      <ProdutoAssociarAgrupadores
        v-if="modalAssociarAgrupador"
        @close="modalAssociarAgrupador = false"
        @submit="aplicarAgrupadores"
      />
    </transition>
    <transition name="slide-popup" mode="out-in">
      <router-view class="view" @close="onClose"></router-view>
    </transition>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Panel from "@/components/Panel";
import FormButton from "@/components/form/FormButton";
import FormButtonMenu from "@/components/form/FormButtonMenu";
import { mapGetters } from "vuex";
import {
  PRODUTO_REMOVE,
  PRODUTO_DESASSOCIAR,
  PRODUTO_ASSOCIAR,
  PRODUTO_DESASSOCIAR_TAGS,
  PRODUTO_ASSOCIAR_TAGS,
  PRODUTO_ASSOCIAR_AGRUPADORES,
  PRODUTO_DESASSOCIAR_AGRUPADORES,
  PRODUTO_CONJUNTO_DISPONIBILIDADE_MASSA
} from "@/store/actions/produto";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import Chip from "@/components/Chip";
import EdicaoEmPlanilha from "@/components/EdicaoEmPlanilha";
import MarketingModules from "@/components/MarketingModules";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { SEGMENTO_LIST } from "@/store/actions/segmento";
import ProdutoAssociarModal from "@/pages/cadastro/produto/ProdutoAssociarModal";
import ProdutoAssociarTags from "@/pages/cadastro/produto/ProdutoAssociarTags";
import ProdutoAssociarAgrupadores from "@/pages/cadastro/produto/ProdutoAssociarAgrupadores";
import { formatVigenciaForDisplay } from "@/pages/comercial/conjunto/vigencia-helpers";

export default {
  name: "ConjuntoTable",
  components: {
    DataTable,
    Panel,
    FormButton,
    FormButtonMenu,
    Chip,
    FormButtonGroup,
    EdicaoEmPlanilha,
    MarketingModules,
    ProdutoAssociarModal,
    ProdutoAssociarTags,
    ProdutoAssociarAgrupadores
  },
  data: () => ({
    headers: [
      { text: "Nome do conjunto", value: "nome" },
      {
        text: "Código interno",
        value: "id_produto_erp",
        align: "center"
      },
      {
        text: "Código de barras",
        value: "codigobarras",
        align: "center"
      },
      {
        text: "Máximo disponível",
        value: "maximo_disponivel",
        align: "center"
      },
      {
        text: "Disponível para venda",
        value: "disponivel",
        align: "center"
      },
      {
        text: "Início da vigência",
        value: "inicio_vigencia",
        align: "center"
      },
      {
        text: "Fim da vigência",
        value: "fim_vigencia",
        align: "center"
      },
      {
        text: "Tem imagem",
        value: "tem_imagem",
        align: "center"
      },
      {
        text: "Opções",
        value: "idproduto",
        clickable: false
      }
    ],
    tableOptions: [
      { text: "Duplicar", value: "clone" },
      { text: "Deletar", value: "delete" }
    ],
    operacoesOptions: [
      { text: "Associar categorias", value: "associar_categoria" },
      { text: "Desassociar categorias", value: "desassociar_categoria" },
      { text: "Associar tags", value: "associar_tags" },
      { text: "Desassociar tags", value: "desassociar_tags" },
      { text: "Associar agrupadores", value: "associar_agrupadores" },
      { text: "Desassociar agrupadores", value: "desassociar_agrupadores" },
      { text: "Habilitar conjuntos", value: "habilitar_conjunto" },
      { text: "Desabilitar conjuntos", value: "desabilitar_conjunto" },
      { text: "Deletar conjuntos", value: "delete" }
    ],
    planilhaOptions: [
      { text: "Editar conjuntos", value: "planilha_conjunto" },
      {
        text: "Editar vínculo produtos ao conjunto",
        value: "planilha_vinculo_produto_conjunto"
      }
    ],
    conjuntoSelecionados: [],
    modalEdicaoEmPlanilha: {
      open: false,
      modelo: "planilha_conjunto"
    },
    modalAssociar: false,
    modalAssociarTags: false,
    modalAssociarAgrupador: false,
    loadingAcao: false,
    loadingRow: {},
    modulosForm: [
      ModulesEnum.PORTFOLIO_WEB,
      ModulesEnum.ORCAMENTO_WEB,
      ModulesEnum.ORCAMENTO_APP,
      ModulesEnum.VENDAMAIS_WEB,
      ModulesEnum.VENDAMAIS_APP,
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.COMMERCE_APP
    ]
  }),
  computed: {
    ...mapGetters([
      "getFornecedorId",
      "moduloFornecedorAtivo",
      "getFornecedorTag"
    ]),
    filters() {
      return [
        { label: "Código interno", query: "codigointerno" },
        { label: "Código de barras", query: "codigobarras" },
        {
          label: "Disponibilidade",
          query: "disponibilidade",
          default: "",
          options: [
            { text: "Todos", value: "" },
            { text: "Disponível", value: "true" },
            { text: "Indisponível", value: "false" }
          ]
        },
        {
          label: "Vínculo de imagem",
          query: "temimagem",
          options: [
            { text: "Todos", value: "" },
            { text: "Com imagem", value: "true" },
            { text: "Sem imagem", value: "false" }
          ]
        }
      ];
    },
    endpoint() {
      return `/api/v1/produtos/datableformat?idfornecedor=${this.getFornecedorId}&tipoProduto=CONJUNTO&filtroSimples=`;
    },
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    }
  },
  watch: {
    getFornecedorId: {
      handler() {
        this.loadData();
      }
    }
  },
  methods: {
    formatVigenciaForDisplay,
    loadData() {
      this.$store.dispatch(SEGMENTO_LIST);
      this.loadingRow = {};
    },
    onClose() {
      this.$refs.datatable.reload();
      this.loadingRow = {};
    },
    onClick(item) {
      this.$router.push(
        `conjunto-produtos/${item.idproduto}/${item.idcadastroextraproduto}`
      );
    },
    onNew() {
      this.$router.push("conjunto-produtos/novo");
    },
    selectOption(item, option) {
      switch (option.value) {
        case "clone":
          return this.onClone(item);
        case "delete":
          return this.onDelete(item);
      }
    },
    onClone(item) {
      const options = {
        title: `Duplicar conjunto '${item.nome}'?`,
        text:
          "Será aberta uma nova tela de cadastro de conjunto com os dados do conjunto selecionado. Nenhum registro será criado até você salvar."
      };
      this.confirmSwal(options, () => {
        this.$router.push({
          path: "conjunto-produtos/novo",
          query: {
            origemIdproduto: item.idproduto,
            origemIdcadastroextraproduto: item.idcadastroextraproduto
          }
        });
      });
    },
    selectOperacao(option) {
      const edicaoPlanilha = option.value.startsWith("planilha");
      if (edicaoPlanilha) {
        this.modalEdicaoEmPlanilha = {
          open: true,
          modelo: option.value
        };
        return;
      }
      if (this.conjuntoSelecionados.length == 0) {
        this.$vueOnToast.pop(
          "warning",
          "Necessário selecionar ao menos um conjunto para aplicar operações em massa"
        );
        return;
      }
      switch (option.value) {
        case "associar_categoria":
          this.modalAssociar = true;
          break;
        case "desassociar_categoria":
          return this.onDesassociarCategorias();
        case "associar_tags":
          this.modalAssociarTags = true;
          break;
        case "desassociar_tags":
          return this.onDesassociarTags();
        case "associar_agrupadores":
          this.modalAssociarAgrupador = true;
          break;
        case "desassociar_agrupadores":
          return this.onDesassociarAgrupadores();
        case "habilitar_conjunto":
          return this.onHabilitarConjuntos();
        case "desabilitar_conjunto":
          return this.onDesabilitarConjuntos();
        case "delete":
          return this.onDeleteMultiple();
      }
    },
    onDelete(item) {
      const options = {
        text: "Essa ação é irreversível.",
        title: `Você confirma a exclusão do conjunto '${item.nome}'?`
      };
      this.confirmSwal(options, () => this.delete(item));
    },
    delete(item) {
      this.loadingRow = {
        ...this.loadingRow,
        [item.idcadastroextraproduto]: true
      };
      this.$store
        .dispatch(PRODUTO_REMOVE, item.idcadastroextraproduto)
        .then(() => {
          this.$vueOnToast.pop("success", "Conjunto removido com sucesso");
          this.$refs.datatable.reload();
          this.loadingRow = {
            ...this.loadingRow,
            [item.idcadastroextraproduto]: false
          };
        })
        .catch(() => {
          this.loadingRow = {
            ...this.loadingRow,
            [item.idcadastroextraproduto]: false
          };
        });
    },
    onDeleteMultiple() {
      const options = {
        text: "Essa ação é irreversível.",
        title: `Você confirma a exclusão de ${this.conjuntoSelecionados.length} conjuntos selecionados?`
      };
      this.confirmSwal(options, () => this.deleteMultiple());
    },
    async deleteMultiple() {
      try {
        this.loadingAcao = true;
        for (const i in this.conjuntoSelecionados) {
          const conjunto = this.conjuntoSelecionados[i];
          await this.$store.dispatch(
            PRODUTO_REMOVE,
            conjunto.idcadastroextraproduto
          );
        }
        this.loadingAcao = false;
        this.$vueOnToast.pop("success", "Conjuntos removidos com sucesso");
        this.$refs.datatable.reload();
      } catch (err) {
        this.loadingAcao = false;
        this.$vueOnToast.pop("error", "Não foi possível deletar conjuntos");
      }
    },
    onDesassociarCategorias() {
      const options = {
        text: "Deseja desassociar as categorias destes conjuntos?",
        title: "Desassociação de Categorias"
      };
      this.confirmSwal(options, () => {
        this.loadingAcao = true;
        const arrayIdsProdutos = this.conjuntoSelecionados.map(
          item => item.idproduto
        );
        this.$store
          .dispatch(PRODUTO_DESASSOCIAR, arrayIdsProdutos)
          .then(() => {
            this.loadingAcao = false;
            this.$vueOnToast.pop(
              "success",
              "Conjuntos desassociados das categorias com sucesso!"
            );
            this.$refs.datatable.reload();
          })
          .catch(() => (this.loadingAcao = false));
      });
    },
    onDesassociarTags() {
      const options = {
        text: "Deseja desassociar as tags destes conjuntos?",
        title: "Desassociação de tags"
      };
      this.confirmSwal(options, () => {
        this.loadingAcao = true;
        const arrayIdsCadastroExtra = this.conjuntoSelecionados.map(
          item => item.idcadastroextraproduto
        );
        this.$store
          .dispatch(PRODUTO_DESASSOCIAR_TAGS, {
            idscadastroextra: arrayIdsCadastroExtra
          })
          .then(() => {
            this.loadingAcao = false;
            this.$vueOnToast.pop(
              "success",
              "Conjuntos desassociados das tags com sucesso!"
            );
            this.$refs.datatable.reload();
          })
          .catch(() => (this.loadingAcao = false));
      });
    },
    aplicaCategorias(categorias) {
      this.modalAssociar = false;
      this.loadingAcao = true;
      const arrayIdsProdutos = [];
      const arrayIdsCadastroExtra = [];
      this.conjuntoSelecionados.forEach(conjunto => {
        arrayIdsProdutos.push(conjunto.idproduto);
        arrayIdsCadastroExtra.push(conjunto.idcadastroextraproduto);
      });
      this.$store
        .dispatch(PRODUTO_ASSOCIAR, {
          setores: categorias,
          alvos: {
            produtos: arrayIdsProdutos,
            idscadastroextra: arrayIdsCadastroExtra
          }
        })
        .then(() => {
          this.loadingAcao = false;
          this.$vueOnToast.pop(
            "success",
            "Conjuntos associados às categorias com sucesso!"
          );
          this.$refs.datatable.reload();
        })
        .catch(() => (this.loadingAcao = false));
    },
    aplicarTags({ tags, substituir }) {
      this.loadingAcao = true;
      const arrayIdsCadastroExtra = this.conjuntoSelecionados.map(
        item => item.idcadastroextraproduto
      );
      const arrayIdstag = tags.map(item => item.idtagpesquisa);
      this.$store
        .dispatch(PRODUTO_ASSOCIAR_TAGS, {
          idscadastroextra: arrayIdsCadastroExtra,
          idstagpesquisas: arrayIdstag,
          substituir
        })
        .then(() => {
          this.loadingAcao = false;
          this.modalAssociarTags = false;
          this.$vueOnToast.pop(
            "success",
            "Conjuntos associados às tags com sucesso!"
          );
          this.$refs.datatable.reload();
        })
        .catch(() => (this.loadingAcao = false));
    },
    aplicarAgrupadores({ agrupadores, substituir }) {
      this.loadingAcao = true;
      const arrayIdsCadastroExtra = this.conjuntoSelecionados.map(
        item => item.idcadastroextraproduto
      );
      const arrayIdsAgrupadores = agrupadores.map(
        item => item.idagrupadortagpesquisa
      );
      this.$store
        .dispatch(PRODUTO_ASSOCIAR_AGRUPADORES, {
          idscadastroextra: arrayIdsCadastroExtra,
          idagrupadores: arrayIdsAgrupadores,
          substituir
        })
        .then(() => {
          this.loadingAcao = false;
          this.modalAssociarAgrupador = false;
          this.$vueOnToast.pop(
            "success",
            "Conjuntos associados aos agrupadores com sucesso!"
          );
          this.$refs.datatable.reload();
        })
        .catch(() => (this.loadingAcao = false));
    },
    onDesassociarAgrupadores() {
      const options = {
        text: "Deseja desassociar os agrupadores destes conjuntos?",
        title: "Desassociação de agrupadores"
      };
      this.confirmSwal(options, () => {
        this.loadingAcao = true;
        const arrayIdsCadastroExtra = this.conjuntoSelecionados.map(
          item => item.idcadastroextraproduto
        );
        this.$store
          .dispatch(PRODUTO_DESASSOCIAR_AGRUPADORES, {
            idscadastroextra: arrayIdsCadastroExtra
          })
          .then(() => {
            this.loadingAcao = false;
            this.$vueOnToast.pop(
              "success",
              "Conjuntos desassociados dos agrupadores com sucesso!"
            );
            this.$refs.datatable.reload();
          })
          .catch(() => (this.loadingAcao = false));
      });
    },
    onHabilitarConjuntos() {
      const options = {
        text: "Os conjuntos selecionados ficarão disponíveis para venda.",
        title: "Habilitar conjuntos em massa"
      };
      this.confirmSwal(options, () => this.atualizarDisponibilidadeMassa(true));
    },
    onDesabilitarConjuntos() {
      const options = {
        text: "Os conjuntos selecionados ficarão indisponíveis para venda.",
        title: "Desabilitar conjuntos em massa"
      };
      this.confirmSwal(options, () =>
        this.atualizarDisponibilidadeMassa(false)
      );
    },
    atualizarDisponibilidadeMassa(habilitar) {
      this.loadingAcao = true;
      const idscadastroextra = this.conjuntoSelecionados.map(
        item => item.idcadastroextraproduto
      );
      this.$store
        .dispatch(PRODUTO_CONJUNTO_DISPONIBILIDADE_MASSA, {
          idscadastroextra,
          habilitar
        })
        .then(() => {
          this.loadingAcao = false;
          this.$vueOnToast.pop(
            "success",
            habilitar
              ? "Conjuntos habilitados com sucesso!"
              : "Conjuntos desabilitados com sucesso!"
          );
          this.$refs.datatable.reload();
        })
        .catch(() => (this.loadingAcao = false));
    }
  },
  created() {
    this.loadData();
  }
};
</script>
